const filterVariations = (variationData) => {
    let variantString = '';

    variationData.forEach((variation, idx, array) => {
        if (Object.keys(variation.values).length) {
            variantString = `${variantString + variation.attributeId}:`;

            variation.values.forEach((value) => {
                if (value.selected) {
                    variantString += value.value;
                }
            });

            if (idx !== array.length - 1) {
                variantString += '/';
            }
        }
    });

    return variantString;
};

const getCarouselList = (element, listName, parentCarousel) => {
    const featuredCarousel = parentCarousel;
    const carouselCallout = featuredCarousel.find('.callout-slot');

    let theListName = listName;

    if (carouselCallout.length) {
        theListName = carouselCallout.attr('value') !== ''
            ? `${listName}: Carousel '${carouselCallout.attr('value')}'`
            : listName;
    }

    return theListName;
};

const getList = (element) => {
    const typeViewOfGrid = $('#datalayerKindList').data('list');
    const parentCarousel = element.closest('.featured-product-carousel').length
        ? element.closest('.featured-product-carousel')
        : element.closest('.featured-carousel-inner');

    let listName;

    if (typeViewOfGrid === 'search') {
        listName = 'search-list';
    } else if (typeViewOfGrid === 'category') {
        listName = `category-list: ${$('#datalayerKindListName').attr('data-list')}`;
    } else if (typeViewOfGrid === 'home') {
        listName = 'Home-list';

        if (parentCarousel.length) {
            listName = getCarouselList(element, listName, parentCarousel);
        }
    } else if (typeViewOfGrid === 'prodView') {
        listName = 'Product-view-list';

        if (parentCarousel.length) {
            listName = getCarouselList(element, 'relacionados-list', parentCarousel);
        }
    } else if (typeViewOfGrid === 'cart') {
        listName = 'Cart page product list';

        if (parentCarousel.length) {
            listName = getCarouselList(element, listName, parentCarousel);
        }
    }

    return listName;
};

const validateElement = elem => (elem === null || elem === undefined ? '' : elem);

const productClickStructure = element => ({
    item_name: $(element).find('.pdp-link > a')[0].innerText,
    item_id: validateElement($(element).data('pid')).toString(),
    price: parseFloat(validateElement($(element)
        .find('.gtmProdPrice')
        .data('pinfo'))
        .toString()),
    item_brand: validateElement($(element)
        .find('.gtmProdBrand')
        .data('pinfo')),
    category: validateElement($(element)
        .find('.gtmProdCategory')
        .data('pinfo')),
    discount: parseFloat(validateElement(element.find('.gtmProdDiscount').data('pinfo'))),
    quantity: 1,
    index: $(element).parent().index() + 1,
});

module.exports = {
    getList,
    productClickStructure,
    filterVariations,
};
